<template>
  <div class="pa-3 ma-3">
    <v-alert-dialog ref="alert"></v-alert-dialog>
    
    <v-dialog max-width="75%" v-model="dialogAddEdit" persistent>
      <v-card>
        <v-card-title>
          {{ editedItem.id_cuenta_bancaria === null ? "Crear" : "Editar" }} Cuenta Bancaria
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="editedItem.concepto"
                label="Concepto"
                outlined
                dense
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-autocomplete
                v-model="editedItem.id_banco"
                :items="bancos"
                :loading="loadingBancos"
                item-text="nombre"
                item-value="id_banco"
                label="Banco"
                outlined
                dense
                hide-details
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="editedItem.numero_cuenta"
                label="No. Cuenta Bancaria"
                outlined
                dense
                hide-details
                maxlength="20"
                counter
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="editedItem.clabe"
                label="CLABE"
                outlined
                dense
                hide-details
                maxlength="18"
                counter
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green" text @click="closeDialogAddEdit">Cancelar</v-btn>
          <v-btn color="red" text @click="saveDialogAddEdit" :loading="loadingSave">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog max-width="65%" v-model="dialogDelete" persistent>
      <v-card>
        <v-card-title>Eliminar Cuenta Bancaria</v-card-title>
        <v-card-text>
          ¿Está seguro de que desea eliminar la cuenta bancaria "{{ editedItem.concepto }}"? Esta acción es permanente y no se puede revertir.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green" text @click="closeDialogDelete">Cancelar</v-btn>
          <v-btn color="red" text @click="saveDialogDelete" :loading="loadingDelete">Eliminar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row>
      <v-col cols="12">
        <v-btn color="primary" @click="openDialogAddEdit(null)">
          Crear Cuenta Bancaria
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-data-table
          :items="items"
          :headers="headers"
          :loading="loading"
        >
          <template v-slot:[`item.banco`]="{ item }">
            {{ getBancoNombre(item.id_banco) }}
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon small class="mr-2" @click="openDialogAddEdit(item)">
              mdi-pencil
            </v-icon>
            <v-icon small class="mr-2" @click="openDialogDelete(item)">
              mdi-delete
            </v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from 'axios'
import VAlertDialog from '@/components/VAlertDialog.vue';

export default {
  components: {
    VAlertDialog
  },
  data: () => ({
    // Configuración para cambiar entre mockup y API real
    useMockup: true, // Cambiar a false para usar API real
    
    dialogAddEdit: false,
    loading: false,
    loadingBancos: false,
    items: [],
    bancos: [],
    headers: [
      {
        text: "Concepto",
        value: "concepto",
        align: "center",
        width: "30%"
      },
      {
        text: "No. Cuenta Bancaria",
        value: "numero_cuenta",
        align: "center",
        width: "20%"
      },
      {
        text: "CLABE",
        value: "clabe",
        align: "center",
        width: "20%"
      },
      {
        text: "Banco",
        value: "banco",
        align: "center",
        width: "20%"
      },
      {
        text: "Acciones",
        value: "actions",
        align: "center",
        width: "10%"
      }
    ],
    editedItem: {
      id_cuenta_bancaria: null,
      concepto: "",
      numero_cuenta: "",
      clabe: "",
      id_banco: null
    },
    defaultEditedItem: {
      id_cuenta_bancaria: null,
      concepto: "",
      numero_cuenta: "",
      clabe: "",
      id_banco: null
    },
    loadingSave: false,
    dialogDelete: false,
    loadingDelete: false,
    
    // Datos mockup - Bancos
    mockupBancos: [
      { id_banco: 1, nombre: "BBVA México" },
      { id_banco: 2, nombre: "Santander" },
      { id_banco: 3, nombre: "Citibanamex" },
      { id_banco: 4, nombre: "Banorte" },
      { id_banco: 5, nombre: "HSBC" },
      { id_banco: 6, nombre: "Scotiabank" },
      { id_banco: 7, nombre: "Inbursa" },
      { id_banco: 8, nombre: "Azteca" },
      { id_banco: 9, nombre: "Afirme" },
      { id_banco: 10, nombre: "BanBajío" }
    ],
    
    // Datos mockup - Cuentas Bancarias
    mockupData: [
      { 
        id_cuenta_bancaria: 1, 
        concepto: "Cuenta operativa principal", 
        numero_cuenta: "0123456789", 
        clabe: "012180001234567897",
        id_banco: 1 
      },
      { 
        id_cuenta_bancaria: 2, 
        concepto: "Cuenta nómina", 
        numero_cuenta: "9876543210", 
        clabe: "014180009876543210",
        id_banco: 2 
      },
      { 
        id_cuenta_bancaria: 3, 
        concepto: "Cuenta de inversión", 
        numero_cuenta: "5555666677", 
        clabe: "002180005555666677",
        id_banco: 3 
      },
      { 
        id_cuenta_bancaria: 4, 
        concepto: "Cuenta proveedores", 
        numero_cuenta: "1122334455", 
        clabe: "072180001122334455",
        id_banco: 4 
      },
      { 
        id_cuenta_bancaria: 5, 
        concepto: "Cuenta ahorros empresa", 
        numero_cuenta: "9988776655", 
        clabe: "021180009988776655",
        id_banco: 5 
      }
    ],
    nextId: 6 // Para generar IDs en el mockup
  }),
  
  mounted() {
    this.getBancos();
    this.getItems();
  },
  
  methods: {
    // ========== MÉTODOS PRINCIPALES (Llaman a mockup o API según configuración) ==========
    getBancos() {
      if (this.useMockup) {
        this.getBancosMockup();
      } else {
        this.getBancosAPI();
      }
    },
    
    getItems() {
      if (this.useMockup) {
        this.getItemsMockup();
      } else {
        this.getItemsAPI();
      }
    },
    
    saveDialogAddEdit() {
      // Validaciones
      if (this.editedItem.concepto == null || this.editedItem.concepto.length === 0 || this.editedItem.concepto.length > 100) {
        this.$refs.alert.setMessage("", "Debe ingresar un Concepto entre 1 y 100 caracteres");
        this.$refs.alert.open();
        return;
      }
      
      if (this.editedItem.numero_cuenta == null || this.editedItem.numero_cuenta.length === 0 || this.editedItem.numero_cuenta.length > 20) {
        this.$refs.alert.setMessage("", "Debe ingresar un Número de Cuenta entre 1 y 20 caracteres");
        this.$refs.alert.open();
        return;
      }
      
      if (this.editedItem.clabe == null || this.editedItem.clabe.length !== 18) {
        this.$refs.alert.setMessage("", "La CLABE debe tener exactamente 18 caracteres");
        this.$refs.alert.open();
        return;
      }
      
      if (this.editedItem.id_banco == null) {
        this.$refs.alert.setMessage("", "Debe seleccionar un Banco");
        this.$refs.alert.open();
        return;
      }

      if (this.useMockup) {
        this.saveDialogAddEditMockup();
      } else {
        this.saveDialogAddEditAPI();
      }
    },
    
    saveDialogDelete() {
      if (this.useMockup) {
        this.saveDialogDeleteMockup();
      } else {
        this.saveDialogDeleteAPI();
      }
    },
    
    // ========== MÉTODOS MOCKUP ==========
    getBancosMockup() {
      this.loadingBancos = true;
      // Simular delay de API
      setTimeout(() => {
        this.bancos = [...this.mockupBancos];
        this.loadingBancos = false;
      }, 300);
    },
    
    getItemsMockup() {
      this.loading = true;
      // Simular delay de API
      setTimeout(() => {
        this.items = [...this.mockupData];
        this.loading = false;
      }, 500);
    },
    
    saveDialogAddEditMockup() {
      this.loadingSave = true;
      
      // Simular delay de API
      setTimeout(() => {
        if (this.editedItem.id_cuenta_bancaria === null) {
          // Crear nuevo
          const newItem = {
            ...this.editedItem,
            id_cuenta_bancaria: this.nextId++
          };
          this.mockupData.push(newItem);
        } else {
          // Editar existente
          const index = this.mockupData.findIndex(item => item.id_cuenta_bancaria === this.editedItem.id_cuenta_bancaria);
          if (index !== -1) {
            this.mockupData[index] = { ...this.editedItem };
          }
        }
        
        this.getItems();
        this.closeDialogAddEdit();
        this.loadingSave = false;
      }, 800);
    },
    
    saveDialogDeleteMockup() {
      this.loadingDelete = true;
      
      // Simular delay de API
      setTimeout(() => {
        const index = this.mockupData.findIndex(item => item.id_cuenta_bancaria === this.editedItem.id_cuenta_bancaria);
        if (index !== -1) {
          this.mockupData.splice(index, 1);
        }
        
        this.closeDialogDelete();
        this.getItems();
        this.loadingDelete = false;
      }, 800);
    },
    
    // ========== MÉTODOS API REAL ==========
    getBancosAPI() {
      this.loadingBancos = true;
      axios
        .get('/Catalogos/ListarBancos')
        .then(response => {
          this.bancos = response.data;
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loadingBancos = false;
        })
    },
    
    getItemsAPI() {
      this.loading = true;
      axios
        .get('/Catalogos/ListarCuentasBancarias')
        .then(response => {
          this.items = response.data;
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        })
    },
    
    saveDialogAddEditAPI() {
      this.loadingSave = true;

      axios({
        method: this.editedItem.id_cuenta_bancaria === null ? 'POST' : 'PUT',
        url: this.editedItem.id_cuenta_bancaria === null ? '/Catalogos/CrearCuentaBancaria' : `/Catalogos/EditarCuentaBancaria/${this.editedItem.id_cuenta_bancaria}`,
        data: {
          concepto: this.editedItem.concepto,
          numero_cuenta: this.editedItem.numero_cuenta,
          clabe: this.editedItem.clabe,
          id_banco: this.editedItem.id_banco
        }
      })
      .then(() => {
        this.getItems();
        this.closeDialogAddEdit();
      })
      .catch(error => {
        if (error.response && error.response.status == 409) {
          this.$refs.alert.setMessage("", "Ya existe una Cuenta Bancaria con el mismo número de cuenta o CLABE.");
          this.$refs.alert.open();
          return;
        }
        console.log(error);
      })
      .finally(() => {
        this.loadingSave = false;
      });
    },
    
    saveDialogDeleteAPI() {
      this.loadingDelete = true;
      axios
        .delete(`/Catalogos/EliminarCuentaBancaria/${this.editedItem.id_cuenta_bancaria}`)
        .then(() => {
          this.closeDialogDelete();
          this.getItems();
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loadingDelete = false;
        });
    },
    
    // ========== MÉTODOS COMUNES ==========
    openDialogAddEdit(editItem = null) {
      if (editItem != null) this.editedItem = Object.assign({}, editItem);
      else this.editedItem = Object.assign({}, this.defaultEditedItem);
      this.dialogAddEdit = true;
    },
    
    closeDialogAddEdit() {
      this.editedItem = Object.assign({}, this.defaultEditedItem);
      this.dialogAddEdit = false;
    },
    
    openDialogDelete(editItem) {
      this.editedItem = Object.assign({}, editItem);
      this.dialogDelete = true;
    },
    
    closeDialogDelete() {
      this.editedItem = Object.assign({}, this.defaultEditedItem);
      this.dialogDelete = false;
    },
    
    // ========== MÉTODOS AUXILIARES ==========
    getBancoNombre(idBanco) {
      const banco = this.bancos.find(b => b.id_banco === idBanco);
      return banco ? banco.nombre : 'N/A';
    }
  }
}
</script>